import { GenAiButton } from "./GenAiButton";
import { isDisprzAtomicSkillSource, isGenAiDisprzAtomicSkillSource, isVectorBasedSource } from "../../../helpers/CommonHelper";
import React from "react";
import text from '../../../locale.en.json';
import { SourcesStore } from "../../../store/store_state";

export const renderAIButton = ({mode = "", sourceId = "", clickHandler = () => {}, style={}}) => {
  const shouldRenderButton = mode === "add" || isDisprzAtomicSkillSource(sourceId) || isVectorBasedSource(sourceId);
  if (shouldRenderButton) {
    return (
      <GenAiButton
        style={style}
        onClick={() => clickHandler()}
     >
        {text.common.generateUsingAi}
      </GenAiButton>
      );
    } else {
      return null;
    }
}